import { createAction, props } from '@ngrx/store';

import { GridListEntity } from '../components/grid-list/grid-list.entity';
import { GridType } from '../domain/grid.domain';

export enum GridActions {
	InitGridList = '[Grid] get grid list',
	RefreshGridList = '[BE][Grid] refresh grid list',
	FetchGridListSuccess = '[BE][Grid] fetch grid list success',
	FetchGridListFail = '[BE][Grid] fetch grid list fail',
	NavigateToGridCreateRoute = '[Grid] navigate to grid create route',
	NavigateToGridEditRoute = '[Grid] navigate to grid edit route',
	ToggleGridStatus = '[Grid] toggle grid status',
	OpenDeleteConfirmationPopup = '[Grid] open delete confirm popup',
	DeleteGrid = '[Grid] delete grid',
	BulkDeleteGrids = '[Grid] delete many grids',
	DeleteGridSuccess = '[BE][Grid] delete grid success',
	DeleteGridFail = '[BE][Grid] delete grid fail',
	DuplicateGrid = '[Grid] duplicate grid',
	DuplicateGridSuccess = '[BE][Grid] duplicate grid success',
	DuplicateGridFail = '[BE][Grid] duplicate grid fail',
}

export const initGridList = createAction(GridActions.InitGridList);

export const refreshGridList = createAction(GridActions.RefreshGridList);

export const fetchGridListSuccess = createAction(
	GridActions.FetchGridListSuccess,
	props<{ gridList: GridListEntity }>()
);

export const fetchGridListFail = createAction(
	GridActions.FetchGridListFail,
	props<{ error: unknown }>()
);

export const navigateToGridCreate = createAction(
	GridActions.NavigateToGridCreateRoute
);

export const navigateToGridEdit = createAction(
	GridActions.NavigateToGridEditRoute,
	props<{ id: number; gridType: GridType; goToVisuTab: boolean }>()
);

export const toggleGridStatus = createAction(
	GridActions.ToggleGridStatus,
	props<{ gridId: number; gridType: GridType }>()
);

export const openDeleteConfirmationPopup = createAction(
	GridActions.OpenDeleteConfirmationPopup,
	props<{
		gridId: Array<number>;
		gridLabel: string;
		gridType: Array<GridType>;
	}>()
);

export const deleteGrid = createAction(
	GridActions.DeleteGrid,
	props<{ gridId: number; gridType: GridType }>()
);

export const bulkDeleteGrids = createAction(
	GridActions.BulkDeleteGrids,
	props<{ gridIds: Array<number> }>()
);

export const deleteGridSuccess = createAction(GridActions.DeleteGridSuccess);

export const deleteGridFail = createAction(
	GridActions.DeleteGridFail,
	props<{ error: unknown }>()
);

export const duplicateGrid = createAction(
	GridActions.DuplicateGrid,
	props<{ gridId: number; gridType: GridType }>()
);

export const duplicateGridSuccess = createAction(
	GridActions.DuplicateGridSuccess,
	props<{ id: number; gridType: GridType }>()
);

export const duplicateGridFail = createAction(
	GridActions.DuplicateGridFail,
	props<{ error: unknown }>()
);
